import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  base_path = 'https://app.prosaudeativa.com.br';

  user; 

  constructor(
    private http: HttpClient,
  ) {

    if(localStorage.getItem('psa_user')){
      this.user = JSON.parse(localStorage.getItem('psa_user'));
    } else {
      this.user = {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        address: {
          street: '',
          number: '',
          district: '',
          city: '',
          region: '',
          zip_code: '',
          country: '',
          complement: ''
        }
      };
    }
  }

  public storageSub= new Subject<string>();
  watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }
  
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${ JSON.stringify(error) }`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  };


  getCategories(type): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    return this.http
      .get(this.base_path + '/trainings/categories/?category='+type, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }


  // ===============================================
  // LOGIN - CADASTRO - PERFIL
  userData(): Observable<any> {
    return this.user;
  }

  doLogin(body): Observable<any> {
    let headers = new HttpHeaders();

    headers.append('Access-Control-Allow-Origin','*');
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');

    return this.http
      .post(this.base_path + '/accounts/login/', body, { headers: headers })
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  registerUser(body): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .post(this.base_path + '/accounts/register/', body, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  updateUser(body): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http
      .post(this.base_path + '/accounts/update/general/', body, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getCEP(zip){
    return this.http
    .get(this.base_path + '/accounts/register/br-address-sugestion/?cep='+zip)
    .pipe(
      retry(2),
      catchError(this.handleError)
    )
  }

  getUser(){
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    return this.http
    .get(this.base_path + '/accounts/user-infos/', httpOptions)
    .pipe(
      retry(2),
      catchError(this.handleError)
    )
  }

  getProgress(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    return this.http
      .get(this.base_path + '/accounts/progress', httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  addProgress(body): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };

    return this.http
      .post(this.base_path + '/accounts/progress/add/', body, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }


  // ===============================================
  // UNIDADES
  getUnities(param): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    return this.http
      .get(this.base_path + '/trainings/units/?'+param, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getUnity(tkn): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    
    return this.http
      .get(this.base_path + '/trainings/units/'+tkn+'/', httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getUnitiesCities(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    return this.http
      .get(this.base_path + '/trainings/units/cities', httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }


  // ===============================================
  //DICAS
  getTips(param): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    return this.http
      .get(this.base_path + '/trainings/tips/?category='+param, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }


  // ===============================================
  // TREINAMENTOS
  getTrainings(param): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    return this.http
      .get(this.base_path + '/trainings/trainings/?category='+param, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }


  // ===============================================
  // EVENTOS
  getEventsDay(param, date): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    
    return this.http
      .get(this.base_path + '/trainings/events/events-on-day/?'+param+'&date='+date, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getEventsMonth(param): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    
    return this.http
      .get(this.base_path + '/trainings/events/month-dates-list/?'+param, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getEventsCities(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    return this.http
      .get(this.base_path + '/trainings/events/cities', httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  getEventsRange(param): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    
    return this.http
      .get(this.base_path + '/trainings/events/events-in-range/?'+param, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }



  getAds(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': 'Token ' + localStorage.getItem('psa_token')
      })
    };
    
    return this.http
      .get(this.base_path + '/trainings/advertisiments/list/', httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

}
